// Instagram section Slider js 


const finder = setInterval(() => {
	
  const s = document.querySelector('.instafeed-new-layout-wrapper');
  if (!s) return;
  clearInterval(finder);

  s.addEventListener('wheel', e => (e.preventDefault(), s.scrollLeft += e.deltaY));

  let x, l, d;
  s.addEventListener('mousedown', e => (d = true, x = e.pageX, l = s.scrollLeft, s.classList.add('dragging')));
  s.addEventListener('mouseup',   () => (d = false, s.classList.remove('dragging')));
  s.addEventListener('mouseleave',() => (d = false, s.classList.remove('dragging')));
  s.addEventListener('mousemove', e => d && (s.scrollLeft = l - (e.pageX - x)));

  s.addEventListener('touchstart', e => (x = e.touches[0].pageX, l = s.scrollLeft));
//   s.addEventListener('touchmove',  e => (s.scrollLeft = l - (e.touches[0].pageX - x)));
  
}, 100);

// Instagram section Slider js End


